import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaSaldosDetalleMovimientosNuevo', {
    template: template,
    controller: NominasNominaSaldosDetalleMovimientosNuevo,
    bindings: {
      nominas: '<',
      saldos: '<',
      onClose: '&',
    },
  })

function NominasNominaSaldosDetalleMovimientosNuevo() {
  let $ctrl = this

  $ctrl.agregar = agregar
  $ctrl.cancelar = cancelar
  $ctrl.destino = undefined
  $ctrl.filtrar = filtrar
  $ctrl.origen = undefined
  $ctrl.saldosOperadora = []

  $ctrl.ajustes = {
    'M1': {id: 68, descripcion: 'Ajuste Cambiario'},
    'M2': {id: 17, descripcion: 'Ajuste Cambiario'},
    'P1': {id: 42, descripcion: 'Ajuste Cambiario PS'},
    'P2': {id: 43, descripcion: 'Ajuste Cambiario PS'},
  }

  function agregar() {
    let ajuste = $ctrl.ajustes[$ctrl.destino.tipo + $ctrl.origen.id_moneda],
      data = {
        cargo: {
          concepto: ajuste.descripcion,
          fecha: $ctrl.origen.fecha,
          id_concepto: ajuste.id,
          id_moneda: $ctrl.origen.id_moneda,
          id_operadora: $ctrl.origen.id_operadora,
          importe: 0,
          operadora: $ctrl.origen.operadora,
          tipo_cambio: $ctrl.origen.tipo_cambio,
        },
        abono: {
          concepto: $ctrl.destino.concepto,
          fecha: $ctrl.origen.fecha,
          id_concepto: $ctrl.destino.id_concepto,
          id_moneda: $ctrl.destino.id_moneda,
          id_operadora: $ctrl.destino.id_operadora,
          importe: 0,
          operadora: $ctrl.destino.operadora,
          tipo_cambio: $ctrl.destino.tipo_cambio,
        },
      }

    $ctrl.onClose({$event: {data: data}})
  }

  function cancelar() {
    $ctrl.onClose({$event: {data: null}})
  }

  function filtrar() {
    $ctrl.saldosOperadora = $ctrl.saldos
      .filter(function (item) {
        return item.id_operadora === $ctrl.origen.id_operadora
          && item.total > 0
      })

    $ctrl.destino = $ctrl.saldosOperadora.length === 1
      ? $ctrl.saldosOperadora[0]
      : undefined
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/saldos/detalle/movimientos/nuevo/component.js